import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TableComponent } from '../../../components/table/table.component';
import { tableModel } from '../../../components/table/model/tableModel';
import { CompanyService } from '../../../services/company.service';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-companies',
  standalone: false,
  templateUrl: './companies.component.html',
  styleUrl: './companies.component.css'
})
export class CompaniesComponent {
  @ViewChild(TableComponent) companiesTable : TableComponent | undefined;
  tableModel: tableModel= {
    columnModel:[
      {columnName:'Raz\u00F3n Social',columnValue:'name'},
      {columnName:'RFC',columnValue:'rfc'},
      {columnName:'Tel\u00E9fono',columnValue:'cellPhone'},
      {columnName:'Correo',columnValue:'email'}
    ],
    dataSource: [],
    editButton:true
    //deleteButton: true
  };
  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;

  private companyService = inject(CompanyService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  constructor(){ }
  
  ngAfterViewInit() {}
  
  ngOnInit(): void {
    this.searchOffersPaginator();
  }

  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchOffersPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/companies/edit', event.id]);
  }

  /*deleteEvent(event: any){
    this.alerta.question('Confirmacion', 'Desea eliminar esta empresa','Eliminar',{
      onAccept: () => {
        this.companyService.deleteCompany(event.id).subscribe({
          next: (response) =>{
            console.log(response);
          }
        });
    }});
  }*/

  searchOffersPaginator(){
    this.loading = true;
    this.companyService.findAllPageableCompany(this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        setTimeout(() => {
          this.companiesTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error al obtener companias', err);
        this.loading = false;
      }
    });
  }

  /*onShowAgregar(): void {
    this.router.navigate(['/companies/add']);
  }*/
}